<template>
  <v-card outlined class="rounded-card">
    <v-card-title class="body-1 font-weight-bold">
      Emails
    </v-card-title>
    <v-card-text class="text--primary">
      <template v-if="!fornecedorCadastro.emails.length">
        <div class="text-center">
          Clique abaixo para adicionar um novo email
          <div class="mt-3">
            <v-btn x-small
                   color="primary"
                   class="rounded-tag-small elevation-0 normal-btn-text" @click="addEmail">
              <v-icon x-small>mdi-plus</v-icon>
              E-mail
            </v-btn>
          </div>
        </div>
      </template>
      <template v-if="fornecedorCadastro.emails.length">
        <v-list>
          <v-list-item dense
                       v-for="(email, i) in fornecedorCadastro.emails"
                       :key="email.key">
            <v-list-item-content>
              <v-text-field
                dense
                outlined
                hide-details
                type="email"
                class="required rounded-tag-small"
                label="E-mail"
                maxlength="100"
                :error="$v.fornecedorCadastro.emails.$each[i].value.$error"
                @blur="$v.fornecedorCadastro.emails.$each[i].value.$touch()"
                v-model="email.value"
              />
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="remove(i)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-row dense class="text-right">
          <v-col cols="12" class="pr-5">
            <v-btn x-small
                   color="primary"
                   class="rounded-tag-small elevation-0 normal-btn-text" @click="addEmail">
              <v-icon x-small>mdi-plus</v-icon>
              E-mail
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import { uniqueId } from 'lodash';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  props: {
    fornecedorCadastro: {
      type: Object,
      required: true,
    },
  },
  methods: {
    addEmail() {
      this.fornecedorCadastro.emails.push({ key: uniqueId(), value: null });
    },
    remove(index) {
      this.fornecedorCadastro.emails.splice(index, 1);
    },
    validate() {
      return this.validateForm();
    },
  },
  validations: {
    fornecedorCadastro: {
      emails: {
        $each: {
          value: {
            required,
            email,
          },
        },
      },
    },
  },
};
</script>
